export default __webpack_public_path__ + "static/media/phani-img.486f0de0.jpeg";